import './assets/css/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import Toast, { useToast } from "vue-toastification";
import "vue-toastification/dist/index.css";
import "vue-loading-overlay/dist/css/index.css";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import Vuetify from '@/config/Vuetify';
import 'vuetify/dist/vuetify.css';
import { createHead } from '@vueuse/head'
import { setHeadInjectionHandler } from '@unhead/vue'

library.add(fas, fab);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import $ from 'jquery'

window.$ = window.jQuery = $

const app = createApp(App)
app.component('VueDatePicker', VueDatePicker);
app.use(router)
app.use(store)
app.use(Vuetify)
app.component('icon', FontAwesomeIcon);
app.use(Toast, {
  position: "top-center",
  timeout: 2500,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: false,
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__fade"
});
const head = createHead()
setHeadInjectionHandler(() => head.unhead || head)
app.use(head)
app.config.globalProperties.$toast = useToast();
app.mount('#app');
